import { createContext, useContext, useState, useCallback } from "react";
import QuickAddDrawer from "@/components/QuickAddDrawer";

const Ctx = createContext(null);
export const useQuickAdd = () => useContext(Ctx) || { openQuickAdd: () => {} };

export function QuickAddProvider({ children }) {
  const [state, setState] = useState({ open: false, entity: null, prefill: null, onSaved: null });

  const openQuickAdd = useCallback((entity, opts = {}) => {
    setState({ open: true, entity, prefill: opts.prefill || null, onSaved: opts.onSaved || null });
  }, []);

  const close = () => setState((s) => ({ ...s, open: false }));

  return (
    <Ctx.Provider value={{ openQuickAdd }}>
      {children}
      <QuickAddDrawer
        open={state.open}
        entity={state.entity}
        prefill={state.prefill}
        onOpenChange={(o) => { if (!o) close(); }}
        onSaved={(doc, entity) => {
          state.onSaved && state.onSaved(doc, entity);
          window.dispatchEvent(new CustomEvent("quickadd:saved", { detail: { entity, doc } }));
        }}
      />
    </Ctx.Provider>
  );
}
